module.exports = __webpack_public_path__ + "media/images/emblems/Court-coat_of_arms-335250a315551adb53ba084524f50864.svg";